module.exports = __webpack_public_path__ + "static/media/multi-image-3-mobile.fa5734a4.png";